'use strict';

export default function ($stateProvider, $urlRouterProvider) {
  'ngInject';

  // $urlRouterProvider.when("/", "/");
  $urlRouterProvider.when("/carousel", "/carousel/list");

  $stateProvider
    .state('carousel', {
      url: '/carousel',
      template: require('./carousel.html'),
      authenticate: true
    })
    .state('carousel.list', {
      url: '/list?category',
      template: require('./list/list.html'),
      controller: 'CarouselListController',
      controllerAs: 'clCtrl'
    })
    .state('carousel.add', {
      url: '/add',
      template: require('./add/add.html'),
      controller: 'CarouselAddController',
      controllerAs: 'caCtrl'
    })
    .state('carousel.edit', {
      url: '/edit/:id',
      template: require('./edit/edit.html'),
      controller: 'CarouselEditController',
      controllerAs: 'ceCtrl'
    })
    .state('carousel.show', {
      url: '/show/:id',
      template: require('./show/show.html'),
      controller: 'CarouselShowController',
      controllerAs: 'csCtrl'
    });
}



// WEBPACK FOOTER //
// ./client/app/carousel/carousel.routes.js